import { ADMIN_FUNCTIONS, SC_MODULES } from '@app/constants/sc.modules';
import warehouseIcon from '@app/assets/images/icons/fk/warehouse.svg';
import InventoryPage from '@modules/school-service/pages/Foodkid/InventoryGroup/InventoryPage';
import { IRouteConfig } from '../route.types';

/**
 * Nhập xuất kho
 */
const warehouseRoutes: IRouteConfig[] = [
    {
        name: 'NHẬP XUẤT KHO',
        icon: warehouseIcon,
        isMenu: true,
        isRoute: true,
        exact: false,
        moduleId: SC_MODULES.SERVICE,
        link: '/warehouse',
        path: '/warehouse',
        main: () => <InventoryPage />,
        functionId: ADMIN_FUNCTIONS.WAREHOUSE_CITY,
    },
];

export default warehouseRoutes;
